/* eslint-disable @angular-eslint/directive-selector */
import {
  Directive,
  Output,
  EventEmitter,
  HostBinding,
  HostListener, Input
} from '@angular/core';

@Directive({
  selector: '[fileDragDrop]'
})
export class DragDropDirective {

  @HostBinding('class.input__fileUpload--dragDrop') public fileOver!: boolean;
  @HostBinding('class.input__fileUpload--disabled') public fileOverDisabled!: boolean;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() public onFileDropped = new EventEmitter < any > ();
  @Input() isDisabled = false;


  // dragover listener
  @HostListener('dragover', ['$event']) public onDragOver(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    if(!this.isDisabled){
      this.fileOver = true;
    } else {
      this.fileOverDisabled = true;
    }
  }
  // dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    this.fileOverDisabled = false;
  }
  // drop listener
  @HostListener('drop', ['$event']) public ondrop(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    this.fileOverDisabled = false;
    const files = evt.dataTransfer?.files;
    if (files?.length > 0) {
      this.onFileDropped?.emit(files);
    }
  }
}
